document.addEventListener('DOMContentLoaded', () => {
    // Scroll Reveal Animation Observer
    const revealElements = document.querySelectorAll('.reveal-on-scroll');
    const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                // Optional: stop observing once revealed
                observer.unobserve(entry.target);
            }
        });
    }, {
        root: null,
        threshold: 0.15, // Trigger when 15% of the element is visible
        rootMargin: "0px 0px -50px 0px" // Slight offset
    });

    revealElements.forEach(el => revealObserver.observe(el));

    // Number Counter Animation Observer
    const counterElements = document.querySelectorAll('.count-up');
    if (counterElements.length) {
        const duration = 1500; // Total animation time in ms
        const frameRate = 30; // Frames per second
        const totalFrames = Math.round((duration / 1000) * frameRate);

        const counterObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    return;
                }
                const element = entry.target;
                const targetValue = parseInt(element.getAttribute('data-target'), 10) || 0;
                let currentFrame = 0;

                // Start counting animation
                const counterInterval = setInterval(() => {
                    currentFrame++;
                    const progress = currentFrame / totalFrames;
                    // Use an ease-out timing function
                    const currentCount = Math.round(targetValue * (1 - Math.pow(1 - progress, 3)));

                    element.innerText = currentCount;

                    if (currentFrame >= totalFrames) {
                        clearInterval(counterInterval);
                        element.innerText = targetValue;
                    }
                }, 1000 / frameRate);

                // Stop observing once animation triggers
                observer.unobserve(element);
            });
        }, {
            threshold: 0.5 // Trigger when 50% visible
        });

        counterElements.forEach(el => {
            // Reserve the final width up front (tabular figures make every digit one
            // ch wide) so the surrounding text does not shift while counting.
            const target = el.getAttribute('data-target') || '0';
            el.style.minWidth = target.trim().length + 'ch';
            // The markup carries the final number so no-JS visitors still see it;
            // reset to 0 here so the animation has somewhere to count up from.
            el.innerText = '0';
            counterObserver.observe(el);
        });
    }

    // Initialize Splide Carousel for Video Analytics
    const carouselElement = document.getElementById('video-analytics-carousel');
    if (carouselElement) {
        new Splide(carouselElement, {
            type: 'loop',
            perPage: 3,
            gap: '2rem',
            pagination: true,
            arrows: true,
            drag: true,
            speed: 300,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
            breakpoints: {
                768: {
                    perPage: 1,
                    gap: '1rem',
                    padding: { left: 0, right: '15%' } // Show a peek of the next slide on mobile
                }
            }
        }).mount();
    }
});
